import { Component, inject, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatToolbar } from '@angular/material/toolbar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { first, Subject, takeUntil } from 'rxjs';
import { Pop } from 'src/app/classes/shared/pop';
import { UiTool } from 'src/app/classes/shared/ui.tools';
import { Project } from 'src/app/interfaces/api/project';
import { ProjectService } from 'src/app/services/api/projects/project.service';
import { ButtonComponent, HelpComponent } from 'ui-library';

@Component({
    selector: 'app-security',
    imports: [
        ButtonComponent,
        FormsModule,
        TranslateModule,
        MatIcon,
        MatFormFieldModule,
        MatToolbar,
        HelpComponent
    ],
    standalone: true,
    templateUrl: './security.component.html',
    styleUrl: './security.component.scss'
})

export class SecurityComponent implements OnDestroy {
    // Services
    private readonly projectService: ProjectService = inject(ProjectService);
    private readonly pop: Pop = inject(Pop)
    private readonly translate: TranslateService = inject(TranslateService);
    private readonly uiTools: UiTool = inject(UiTool);

    // Component API
    helpLink: string = 'https://docs.unifieldsoftware.com/user-guide/projects/settings/#project-security-and-privacy';
    project!: Project;
    destroy$ = new Subject<void>();
    loading: boolean = true;

    constructor() {
        this.projectService.currentProject.pipe(takeUntil(this.destroy$)).subscribe(project => {
            this.project = project;
            this.loading = false;
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    genKey(type: string) {
        const array = new Uint8Array(32);
        crypto.getRandomValues(array);
        const key = Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
        if (type == "flow") {
            this.project.flowAccessKey = key;
        } else {
            this.project.accessKey = key;
        }
    }

    saveKey(type: string) {
        let query: any = {
            id: this.project.id
        }
        if (type == "flow") {
            query["flowAccessKey"] = this.project.flowAccessKey;
        } else {
            query["accessKey"] = this.project.accessKey;
        }

        this.projectService.setProject(query).pipe(first()).subscribe(() => {
            if (type == "flow") {
                this.pop.toast(this.translate.instant('settings.project.key_automation_saved'), 'success', 4000, 'edit');
            } else {
                this.pop.toast(this.translate.instant('settings.project.key_api_saved'), 'success', 4000, 'edit');
            }
        })
    }

    copy(text: string = '') {
        this.uiTools.copy(text);
    }
}
